export {default} from './TitleXsSm';


// WEBPACK FOOTER //
// ./src/components/Project/TitleXsSm/index.js